import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
    server: {
        DATABASE_URL: z.string().url(),
        BASE_URL: z.string(),
        SMTP_HOST: z.string(),
        SMTP_PORT: z.preprocess((val) => parseInt(val as string, 10), z.number()),
        SMTP_USER: z.string(),
        SMTP_PASSWORD: z.string(),
        RECAPTCHA_SECRET_KEY: z.string(),
    },
    client: {
        NEXT_PUBLIC_RECAPTCHA_SITE_KEY: z.string(),
    },
    experimental__runtimeEnv: {
        NEXT_PUBLIC_RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
    },
});
